import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import { Container } from './styles';
import api from '../../services/api';

const SCROLL_RATIO = 0.8;

export default function Categories({ }) {
  const [categoriesWithTopImage, setCategoriesWithTopImage] = useState([]);

  const divCategories = React.createRef();

  useEffect(() => {
    getCategoriesWithTopImages();
  }, []);

  const getCategoriesWithTopImages = async () => {
    try {
      const response = await api.get('categories/top-images')
      if (response.status === 200) {
        setCategoriesWithTopImage(response.data)
      } else {
        setCategoriesWithTopImage([])
      }
    } catch (err) {
      console.log(err)
      setCategoriesWithTopImage([])
    }
  }

  const handleNextPage = () => {
    if (!divCategories.current) return;
    divCategories.current.scrollBy({
      left: divCategories.current.clientWidth * SCROLL_RATIO,
      behavior: 'smooth',
    });
  }

  const handleBackPage = () => {
    if (!divCategories.current) return;
    divCategories.current.scrollBy({
      left: -divCategories.current.clientWidth * SCROLL_RATIO,
      behavior: 'smooth',
    });
  }

  if (!categoriesWithTopImage || categoriesWithTopImage.length === 0) {
    return null
  }

  return (
    <Container>
      <>
        <h2>{"Compre por categoria"}</h2>
        <div className='carousel'>
          <button type="button" className='nav-arrow nav-prev' onClick={handleBackPage} aria-label="Voltar">
            <FiChevronLeft />
          </button>
          <div ref={divCategories} className='categories'>
            {categoriesWithTopImage && categoriesWithTopImage.map((highlight) => (
              highlight.link_personalizado_topo ? (
                <a
                  key={highlight.id}
                  href={highlight.link_personalizado_topo}
                  target={highlight.nova_aba_topo ? "_blank" : undefined}
                  rel={highlight.nova_aba_topo ? "noopener noreferrer" : undefined}
                >
                  <div className='category'>
                    <img src={highlight.base64Imagem} alt={highlight.nome} />
                  </div>
                  {highlight.nome}
                </a>
              ) : (
                <Link key={highlight.id} to={`/produtos/${highlight.tipo === "C" ? "categoria" : "subcategoria"}/${highlight.url}/${highlight.id}`}>
                  <div className='category'>
                    <img src={highlight.base64Imagem} alt={highlight.nome} />
                  </div>
                  {highlight.nome}
                </Link>
              )
            ))}
          </div>
          <button type="button" className='nav-arrow nav-next' onClick={handleNextPage} aria-label="Avançar">
            <FiChevronRight />
          </button>
        </div>
      </>
    </Container>
  );
}
